export const CREATE_TREE = 'CREATE_TREE';
export const GET_FIELD_VALUE = 'GET_FIELD_VALUE';
export const GET_SPOUSE_STATE = 'GET_SPOUSE_STATE';
export const CANCEL_INTRO_ANIMATION = 'CANCEL_INTRO_ANIMATION';